import { getCookie, setCookie } from '@/utils/functions';
import { useEffect, useState } from 'react';

const MODAL_COOKIE_NAME = 'BDModalClosed';

const useNewBankDetailsModal = () => {
  const [isModalShown, setIsModalShown] = useState<boolean>(false);

  useEffect(() => {
    const modalClosed = getCookie(MODAL_COOKIE_NAME);

    if (!modalClosed || modalClosed === 'false') {
      setIsModalShown(true);
    }
  }, []);

  const handleModalClose = (): void => {
    setCookie(MODAL_COOKIE_NAME, 'true', 365); // Store for 1 year
    setIsModalShown(false);
  };

  return { isModalShown, handleModalClose };
};

export default useNewBankDetailsModal;
